<template>
    <div class="text">
        <!-- 过滤文本 -->
		<p v-html="formatRichText(text)" :style="textStyle"></p>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"

    export default {
        name: "desc-text",
        components: {
            // CargoItem
            // CargoNormal,
        },
        props: {
            // config: {
            //     type: Object,
            //     required: false,
            // },
			text: {
			    type: String,
			    required: false,
			},
			textStyle:{
				type: Object,
				required: false,
				default:()=>{
					return {
						WebkitLineClamp:3,
					}
					// '-webkit-line-clamp':3
				}
			}
        },
        data() {
            return {
                
            }
        },
        created() {
        },
        computed: {
            // ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            formatRichText(html){
				let newContent = html;
            	// newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
            	// 	match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
            	// 	match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
            	// 	match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
            	// 	return match;
            	// });
				
				newContent = newContent.replace(/\<img[^>]*>/gi, '');
    //         	newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
    //         		match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
    //         		return match;
    //         	});
				
    //         	newContent = newContent.replace(/<br[^>]*\/>/gi, '');
    //         	newContent = newContent.replace(/\<img[^>]*>/gi, '');
            	
    //         	newContent = newContent.replace(/<p[^>]*>/gi,'<p>')
				
				newContent = newContent.replace(/(<([^>]+)>)/ig, '');
				newContent = newContent.replace(/\s+/g,"");
            	return newContent;
            },
        },
        watch: {
            text: {
                handler: (e)=>{
					console.log(1111111)
					// return this.formatRichText(e)
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .text {
        p{
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 99;
			text-overflow: ellipsis;
			overflow: hidden;
			
			text-indent: 2em;
			text-align: justify;
			
			// text-align-last: justify;

		}
    }
</style>
